import React from 'react'
import PropTypes from 'prop-types'
import { intlMessageShape } from 'sb-react-intl'
import cx from 'classnames'

import LinkWithIcon from 'components/ui/LinkWithIcon/LinkWithIcon'
import { Menu, MenuList, MenuButton, MenuLink } from 'components/_new/ui/Menu'

import s from './HeaderNavDropMenu.scss'


const HeaderNavDropMenu = ({ className, children, dropListClassName, items, dataTestId }) => (
  <Menu toggleOnHover>
    {
      ({ isOpen }) => (
        <div className={cx(className, { [s.menuOpen]: isOpen })} role="none">
          <MenuButton className={s.head} dataTestId={dataTestId} role="menuitem">
            {children}
          </MenuButton>
          <MenuList className={cx(s.dropList, dropListClassName)}>
            {
              items.map(({ id, className, title, icon, emojiIcon, to, toOLD, redirect, brand, dataTestId, onClick }, index) => (
                <MenuLink
                  key={index}
                  className={cx(s.dropListItem, className)}
                  component={LinkWithIcon}
                  {...{ title, icon, emojiIcon, id, to, toOLD, redirect, brand, dataTestId, onClick }}
                />
              ))
            }
          </MenuList>
        </div>
      )
    }
  </Menu>
)

HeaderNavDropMenu.propTypes = {
  children: PropTypes.element.isRequired,
  dropListClassName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.exact({
      title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape(intlMessageShape),
      ]).isRequired,
      onClick: PropTypes.func,
      to: PropTypes.string,
      toOLD: PropTypes.string,
      id: PropTypes.string,
      brand: PropTypes.bool,
      icon: PropTypes.string,
      emojiIcon: PropTypes.string,
      dataTestId: PropTypes.string,
    }).isRequired
  ),
  className: PropTypes.string,
}


export default HeaderNavDropMenu
